import React from 'react';
import './LensOnlyAvailability.scss';

const LensOnlyAvailability = props => {
  const {
    handleChange,
    enterLocationAddToCart,
    pickLocationaddTocart,
    invalidPinCode,
    dataLocale,
  } = props;
  const {
    PLEASE_ENTER_PINCODE_CHECK_AVAILABILITY,
    GO,
    ENTER_YOUR_PINCODE,
    PLEASE_ENTER_VALID_PINCODE,
    LENS_ONLY_PRODUCTS_ARE_AVAILABLE,
    LENS_ONLY_PRODUCTS_ARE_NOT_AVAILABLE,
  } = dataLocale;
  return (
    <div className="pincode-availability">
      <div className="msg-pincode text-black">{PLEASE_ENTER_PINCODE_CHECK_AVAILABILITY}</div>
      <div className="pin-container">
        <input
          className="span9 input-field"
          maxLength="6"
          placeholder={ENTER_YOUR_PINCODE}
          type="text"
          onChange={ev => handleChange(ev)}
        />
        <button
          className="bold text-uppercase"
          id="pin-availibility"
          onClick={() => pickLocationaddTocart()}
        >
          {GO}
        </button>
        {invalidPinCode ? (
          <div className="lens-express-error alert alert-danger">{PLEASE_ENTER_VALID_PINCODE}</div>
        ) : (
          ''
        )}
      </div>
      {enterLocationAddToCart && enterLocationAddToCart.code === 'REVERSE_PICKUP_NOT_AVAILABLE' && (
        <div className="resp-msg alert alert-danger">{LENS_ONLY_PRODUCTS_ARE_NOT_AVAILABLE}</div>
      )}
      {enterLocationAddToCart && enterLocationAddToCart.code === 'SUCCESS' && (
        <div className="resp-msg alert alert-success">{LENS_ONLY_PRODUCTS_ARE_AVAILABLE}</div>
      )}
    </div>
  );
};

export default LensOnlyAvailability;
